export default function CedarRapidsFinalCTA() {
  return (
    <section className="bg-[#0F2240] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#F6C344]/15 mx-auto mb-6">
          <i className="ri-passport-line text-[#F6C344] text-3xl"></i>
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-5">
          Ready to Get Your Expedited Passport in Cedar Rapids?
        </h2>
        <p className="text-white/70 text-lg max-w-xl mx-auto mb-8 leading-relaxed">
          Do not let an expired passport cancel your trip. Start your emergency or expedited passport application today and travel with confidence.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
        <p className="text-white/40 text-xs mt-6">
          A+ BBB Rating &middot; Registered State Department Courier &middot; 20+ Years Experience
        </p>
      </div>
    </section>
  );
}